export default __webpack_public_path__ + "assets/icons/whole-calculate.978c6598.svg";